
  var editorScriptEntry = require('/home/builduser/work/12acb351b62a96cd/packages/profile-page-bob/src/editor.app.ts');

  
    if (editorScriptEntry.default) {
      module.exports = editorScriptEntry.default;
    } else {
      const { editorScriptBuilder } = require('@wix/bob-widget-services');
      const { editorReadyWrapper, createFlowAPIFabric, exportsWrapper } = require('@wix/yoshi-flow-editor/runtime/esm/editorScript.js');

      const biLogger = require('/home/builduser/work/12acb351b62a96cd/packages/profile-page-bob/target/generated/bi/createBILogger.ts').createOwnerBILogger;

      

  const { initI18n: initI18n } = require('@wix/yoshi-flow-editor/runtime/esm/i18next/init');


      

    var createExperiments = null;
    var createWidgetExperiments = null;
    

      
const { createHttpClient } = require('@wix/yoshi-flow-editor/runtime/esm/controller/httpClientProp');
    


      const sentryConfig = {
        DSN: 'https://1d7d0a2217a04496808b11f7603693e5@sentry-next.wixpress.com/7856',
        id: 'undefined',
        projectName: 'profile-page-bob',
        teamName: 'undefined',
        errorMonitor: true,
      };
      const experimentsConfig = {"centralized":true,"scopes":[]};
      const translationsConfig = {"icuEnabled":true,"defaultTranslationsPath":"/home/builduser/work/12acb351b62a96cd/packages/profile-page-bob/src/assets/locales/messages_en.json","availableLanguages":["ar","bg","ca","cs","da","de","el","en","es","fi","fr","he","hi","hr","hu","id","it","ja","ko","lt","lv","ms","nl","no","pl","pt","ro","ru","sk","sl","sv","th","tl","tr","uk","vi","zh"]};
      const defaultTranslations = {"app.widget.welcome":"Welcome","app.page.settings.elements.panel.title":"Page Title","app.fflist.demo-member-nickname.1":"Christabelle Dean (Demo)","app.widget.gfpp.change-layout":"Change Layout","app.empty-state.not-found.title":"We can’t find the page you’re looking for","app.settings.elements.panel.member-menu":"Member Menu","app.ffmodal.tab.followers":"Followers","app.ffmodal.empty-state.following-others":"When {memberName} follows someone, you’ll see them here.","app.settings.manage.menu.panel.followers.title":"Followers/Following","app.error-state.page-load.button":"Try Again","app.error-state.page-load.title":"We couldn’t load this page","app.profile-page.horizontal-menu.unified-manager.gfpp":"Manage Member Pages","app.page.title.private":"Account","app.empty-state.not-found.button":"Go to Home","editor.member-menu.label":"Member Menu","app.settings.manage.menu.panel.title":"Manage and Navigate","app.fflist.demo-member-nickname.2":"Tom Grey (Demo)","app.empty-state.not-found.description":"This page doesn’t exist. Go to Home and keep exploring.","app.settings.manage.menu.panel.manage-and-navigate-renaming.cta":"Manage and Navigate","app.widget.gfpp.manage-member-privacy":"Manage member privacy","app.settings.manage.menu.panel.unified-manager.cta":"Add or Remove Tabs","app.ffmodal.header.close":"Close","app.empty-state.user-is-blocked.button":"See Blocked Members","app.ffmodal.empty-state.following-yourself":"When you follow someone, you’ll see them here.","app.fflist.cta.follow.label":"Follow {memberName}","app.settings.defaults.greetingsPretext":"to","app.settings.elements.panel.member-card":"Member Card","app.page.sausage-bar.cta.manage-member-pages.title":"Manage Member Pages","app.settings.tabs.design":"Design","app.settings.layout.preset.full-width":"Full Width","app.settings.manage.menu.panel.item.action.delete-tab":"Delete Tab","app.settings.manage.menu.panel.item.edit-label.validation-message":"Page Title should be 1 character or more with no special characters or emojis.","app.profile-page.expandable-menu.unified-manager.gfpp":"Manage Member Pages","app.page.profile.title":"Profile","app.empty-state.user-is-blocked.title":"You blocked {memberName}","app.settings.manage.menu.panel.item.subtitle.public":"Public","app.fflist.cta.follow":"Follow","app.settings.manage.menu.panel.followers.value":"Public · Not shown in menu","app.fflist.cta.following.label":"Following {memberName}","app.settings.layout.preset.title":"Page Layout","app.settings.tabs.main":"Main","app.settings-page.unified-manager.gfpp":"Manage Member Pages","app.profile-page.unified-manager.gfpp":"Manage Member Pages","app.settings.manage.menu.panel.item.subtitle.private":"Private","app.page.title":"Member Page","app.settings.manage.menu.panel.manage-member-privacy.cta":"Manage Member Privacy","app.settings.manage.menu.panel.add-more-tabs.cta":"Add More Tabs","app.settings-page.horizontal-menu.unified-manager.gfpp":"Manage Member Pages","app.page.sausage-bar.tabs-label":"{tabsCount, plural, one {1 tab} other {{tabsCount,number} tabs}}","app.ffmodal.tab.following":"Following","app.ffmodal.empty-state.followers-others":"When someone follows {memberName}, you’ll see them here.","app.page.settings.elements.panel.member-menu":"Settings Menu","app.settings.layout.preset.subtitle":"Choose a layout:","app.ffmodal.empty-state.followers-yourself":"When people follow you, you’ll see them here.","app.fflist.cta.following":"Following","app.settings.manage.menu.panel.item.action.edit-tab-name":"Edit Tab Name","app.settings.label":"Configure Widget","app.settings.bp.banner.desktop-and-tablet":"Changes apply to desktop and tablet. <1>Learn More</1>","app.page.settings.title":"Account Settings","app.empty-state.user-is-blocked.description":"Member’s content is not available for you to see anymore.","app.settings.layout.preset.cards":"Cards","app.page.title.public":"Profile","app.settings-page.expandable-menu.unified-manager.gfpp":"Manage Member Pages","members-menu.gfpp.manage-and-navigate":"Manage and Navigate"};

      const createFlowAPI = createFlowAPIFabric({
        sentryConfig,
        experimentsConfig,
        translationsConfig,
        defaultTranslations,
        biLogger,
        shouldUseEssentials: true,
        artifactId: 'profile-page-bob',
        appDefId: 'b976560c-3122-4351-878f-453f337b7245',
        optionalDeps: {
          initI18n,
          createExperiments,
          createHttpClient
        },
        localeDistPath: 'assets/locales',
      });

      const useAPIsFromExports = typeof editorScriptEntry.exports === "function";

      function wrapEditorReady(eReady) {
        try {
          return editorReadyWrapper({
            createFlowAPI,
            editorReady: eReady,
            shouldSkipAPIOverrides: useAPIsFromExports,
          });
        } catch (e) {
          console.error(e);
          throw e;
        }
      }

      let wrappedEditorReady = wrapEditorReady(editorScriptEntry.editorReady);
      if (false) {
        const hot = require('@wix/yoshi-flow-editor/build/cjs/wrappers/editorScriptHot.js').hot;
        wrappedEditorReady = hot(module, wrappedEditorReady);
      }

      let builder = editorScriptBuilder();
      if (editorScriptEntry.editorReady) {
        builder = builder.withEditorReady(wrappedEditorReady);
      }

      if (editorScriptEntry.exports) {
        builder = builder.withExports(useAPIsFromExports ? exportsWrapper(editorScriptEntry.exports) : editorScriptEntry.exports);
      }

      if (editorScriptEntry.onEvent) {
        builder = builder.withEventHandler(editorScriptEntry.onEvent);
      }
      const controllerWidgetManifests = [];
      
      const userController_0 = require('/home/builduser/work/12acb351b62a96cd/packages/profile-page-bob/src/components/FFList/editor.controller.ts');

      const model_0 = require('/home/builduser/work/12acb351b62a96cd/packages/profile-page-bob/src/components/FFList/model.ts').default;

      const manifest_0 = userController_0 ? userController_0.default || userController_0 : {};
      if (!manifest_0.type) {
        manifest_0.type = "b976560c-3122-4351-878f-453f337b7245-zuaoa";
      }
      if (!manifest_0.getExports && model_0) {
        manifest_0.getExports = () => ({"b976560c-3122-4351-878f-453f337b7245-zuaoa": model_0.getExports()});
      }
      if (userController_0 && userController_0.getWidgetManifest) {
        controllerWidgetManifests.push({ widgetId: "b976560c-3122-4351-878f-453f337b7245-zuaoa", getWidgetManifest: userController_0.getWidgetManifest});
      }

      builder = builder.withWidget(manifest_0);
  
      const userController_1 = require('/home/builduser/work/12acb351b62a96cd/packages/profile-page-bob/src/components/FFModal/editor.controller.ts');

      const model_1 = require('/home/builduser/work/12acb351b62a96cd/packages/profile-page-bob/src/components/FFModal/model.ts').default;

      const manifest_1 = userController_1 ? userController_1.default || userController_1 : {};
      if (!manifest_1.type) {
        manifest_1.type = "b976560c-3122-4351-878f-453f337b7245-xhv4l";
      }
      if (!manifest_1.getExports && model_1) {
        manifest_1.getExports = () => ({"b976560c-3122-4351-878f-453f337b7245-xhv4l": model_1.getExports()});
      }
      if (userController_1 && userController_1.getWidgetManifest) {
        controllerWidgetManifests.push({ widgetId: "b976560c-3122-4351-878f-453f337b7245-xhv4l", getWidgetManifest: userController_1.getWidgetManifest});
      }

      builder = builder.withWidget(manifest_1);
  
      const userController_2 = require('/home/builduser/work/12acb351b62a96cd/packages/profile-page-bob/src/components/SettingsPage/editor.controller.ts');

      const model_2 = require('/home/builduser/work/12acb351b62a96cd/packages/profile-page-bob/src/components/SettingsPage/model.ts').default;

      const manifest_2 = userController_2 ? userController_2.default || userController_2 : {};
      if (!manifest_2.type) {
        manifest_2.type = "b976560c-3122-4351-878f-453f337b7245-uuc0d";
      }
      if (!manifest_2.getExports && model_2) {
        manifest_2.getExports = () => ({"b976560c-3122-4351-878f-453f337b7245-uuc0d": model_2.getExports()});
      }
      if (userController_2 && userController_2.getWidgetManifest) {
        controllerWidgetManifests.push({ widgetId: "b976560c-3122-4351-878f-453f337b7245-uuc0d", getWidgetManifest: userController_2.getWidgetManifest});
      }

      builder = builder.withWidget(manifest_2);
  
      const userController_3 = require('/home/builduser/work/12acb351b62a96cd/packages/profile-page-bob/src/components/Widget1/editor.controller.ts');

      const model_3 = require('/home/builduser/work/12acb351b62a96cd/packages/profile-page-bob/src/components/Widget1/model.ts').default;

      const manifest_3 = userController_3 ? userController_3.default || userController_3 : {};
      if (!manifest_3.type) {
        manifest_3.type = "b976560c-3122-4351-878f-453f337b7245-mty3l";
      }
      if (!manifest_3.getExports && model_3) {
        manifest_3.getExports = () => ({"b976560c-3122-4351-878f-453f337b7245-mty3l": model_3.getExports()});
      }
      if (userController_3 && userController_3.getWidgetManifest) {
        controllerWidgetManifests.push({ widgetId: "b976560c-3122-4351-878f-453f337b7245-mty3l", getWidgetManifest: userController_3.getWidgetManifest});
      }

      builder = builder.withWidget(manifest_3);

      if (editorScriptEntry.getAppManifest || controllerWidgetManifests.length) {
        const customGetAppManifest = async (...params) => {
          const [{ appManifestBuilder }, editorSDK, contextParams] = params;
          const flowAPI = await createFlowAPI(editorSDK, contextParams);
          controllerWidgetManifests.forEach(({ widgetId, getWidgetManifest}) => {
            appManifestBuilder.configureWidget(widgetId, (builder) => getWidgetManifest(builder, editorSDK, flowAPI));
          });

          if (editorScriptEntry.getAppManifest) {
            return editorScriptEntry.getAppManifest(...params, flowAPI);
          }

          return appManifestBuilder.build();
        };
        builder = builder.withAppManifest(customGetAppManifest);
      }
      var result = builder.build();
      module.exports = result;
  }
  
